export class EntryConstants {
  static EntryTaken = "0.0";
  static EntryMissed = "1.0";
  static EntrySkipped = "2.0";
}
